import { useScrollTo } from '@/hooks/useScrollTo';

export default function AppSection() {
  const scrollTo = useScrollTo();

  return (
    <section id="app" className="py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20coral%20and%20amber%20flowing%20shapes%2C%20modern%20mobile%20entertainment%20concept%2C%20smooth%20curved%20lines%20with%20gentle%20light%20effects%2C%20minimal%20atmospheric%20design%2C%20digital%20media%20streaming%20platform%20aesthetic%2C%20clean%20elegant%20background%20texture%2C%20professional%20app%20promotion%20visual%20style&width=1600&height=600&seq=app-bg-nc&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/85 to-primary-700/85"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
          <i className="ri-smartphone-line"></i>
          随时随地
        </div>
        <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
          移动追剧
        </h2>
        <p className="text-background-50/85 text-sm md:text-base max-w-lg mx-auto mb-8">
          嫩草视频全面适配手机浏览器，无需下载 App，打开浏览器即可随时随地畅享妖精视频、桃花视频等全网热播影视高清在线观看
        </p>
        <button
          onClick={() => scrollTo('media')}
          className="px-8 py-3 bg-background-50 hover:bg-background-100 text-primary-600 font-medium rounded-full whitespace-nowrap cursor-pointer transition-all text-sm md:text-base inline-flex items-center gap-2"
        >
          <i className="ri-play-circle-fill"></i>
          开始追剧
        </button>
      </div>
    </section>
  );
}